import { render, staticRenderFns } from "./KeyTermsCard.vue?vue&type=template&id=565c596b&scoped=true"
import script from "./KeyTermsCard.vue?vue&type=script&lang=js"
export * from "./KeyTermsCard.vue?vue&type=script&lang=js"
import style0 from "./KeyTermsCard.vue?vue&type=style&index=0&id=565c596b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565c596b",
  null
  
)

export default component.exports